import React from "react";
import {
    Box,
    TextField,
    FormControl,
    InputAdornment,
    InputLabel,
    Input,
    IconButton,
    Button,
    Typography,
    Select,
    MenuItem,
    FormHelperText,
    Alert,
    Tabs,
    Tab,
    useScrollTrigger,
    Checkbox,
    Stack,
    Modal as MuiModal,
} from "@mui/material";
import {
    AccountCircleOutlined,
    Visibility,
    VisibilityOff,
    LockOutlined,
    Group,
    IosShareOutlined,
    Close as CloseIcon,
} from "@mui/icons-material";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range, flatten } from "lodash";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA, SelectA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import { ActiveHighPriority } from "./active-high-priority";
import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BoltIcon from "@mui/icons-material/Bolt";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { filterColumns } from "../column-manager";

import useDebounce from "../../../../hooks/useDebounce";
import SelectedCaseChip from "./components/selected-cases-chip";
import StaticSelectedCasesList from "./components/selected-cases-list";
import SelectedCasesList from "./components/selected-cases-list";
import { toast } from "react-hot-toast";
import { NeedUnassignedList } from "./features/need-unassigned-list";
import BulkModalAssign from "../allocations/features/bulk-assign/bulk-assign-modal";
import UpdateDataModal from "./features/update-data-modal";
import ExportAllocations from "./features/export-allocations";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ToolbarWrapper from "../../../components/toolbar-wrapper";
import TableUtilityBar from "./features/table-utility-bar";
import SelectedAssignDialog from "./features/selected-assign-dialog";

import { useHistory } from "react-router-dom";
import useModalState from "../../../../hooks/use-modal-state";
import AutoAssignDialogFull from "./features/auto-assign-dialog-full";

import { removeNullValueFromObject } from "../../../../utility/object-related";

const durationPulgin = require("dayjs/plugin/duration");
dayjs.extend(durationPulgin);

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

const centeredMuiModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
        xs: 3 / 4,
        md: 1 / 2,
        lg: 1 / 3,
    },
    bgcolor: "background.paper",
    border: "2px solid #000",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    {/* <Typography>{children}</Typography> */}
                    <Stack direction={"column"} spacing={2}>
                        {children}
                    </Stack>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const getTotalWeekOfCurrentMonth = () => {
    return Math.ceil(dayjs().daysInMonth() / 7);
};

const getWeekOfMonth = () => {
    return dayjs.duration().weeks();
};

export const ActiveSameContact = (props) => {
    const [value, setValue] = React.useState(0);
    const {
        roles,
        user,
        users,
        Designations,
        Departments,
        Languages,
        Districts,
        map,
        Shifts,
    } = useSelector((state) => state.user || {});

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Box sx={{ width: "100%" }}>
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    overflow: "hidden",
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        overflowX: "auto",
                    }}
                >
                    <Tab label="All" {...a11yProps(0)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <List
                    heading={""}
                    sx={{ fontSize: ".1em" }}
                    type={"active"}
                    socket={props.socket}
                />
            </CustomTabPanel>

        </Box>
    );
};

export const List = ({ heading, type, socket }) => {
    const history = useHistory();

    const {
        roles,
        user,
        users,
        Designations,
        Departments,
        Languages,
        Districts,
        map,
    } = useSelector((state) => state.user || {});
    const userStore = useSelector((state) => state.user || {});

    /**
     * State for loading the list
     */
    const [listLoading, setListLoading] = useState(true);

    const [grouped, setGrouped] = useState(type === "active"); //Disabled grouping

    const [active, setActive] = useState("Employees");
    const [data, setData] = useState([]);

    // this map will store the map of the mother id with its cases, will help in history
    // if only one case exists means no history so the value for that mother id will be false
    const [dataMap, setDataMap] = useState(new Map());

    const [groupedData, setGroupedData] = useState([]);
    const [open, setOpen] = useState(false);
    const [action, setAction] = useState("new");
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [assigning, setAssigning] = useState(false);
    const [assignCompleted, setAssignCompleted] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [needToBeUnassignedCases, setNeedToBeUnassignedCases] = useState(
        new Map()
    );

    // this state won't change when there is new data
    const [staticSelectedRows, setStaticSelectedRows] = useState(new Map());

    const [activeSelectedAssign, setActiveSelectedAssign] = useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [count, setCount] = useState(0);
    const [selectedSankalpData, setSelectedSankalpData] = useState(null);
    const [openAssignSelected, setOpenAssignSelected] = useState(false);
    const [selectedAgents, setSelectedAgents] = useState({});

    const [openAssignAutoFiltered, setOpenAssignAutoFiltered] = useState(false);
    const [filteredOverview, setFilteredOverview] = useState(null);
    const [assignOverview, setAssignOverview] = useState(null);
    const [assigningFilteredState, setAssigningFilteredState] = useState(false);
    const [assignFilteredCases, setAssignFilteredCases] = useState([]);

    const [assignSelectedCompleted, setAssignSelectedCompleted] = useState(false);
    const [assigningSelected, setAssigningSelected] = useState(false);

    const [isUnassigning, setIsUnassigning] = useState(false);
    const [isFetchingSelectedCasesDetails, setIsFetchingSelectedCasesDetails] =
        useState(false);

    const [editOpen, setEditOpen] = useState(false);

    const [selectedCase, setSelectedCase] = useState(null);
    const [changedStatus, setChangeStatus] = useState(null);
    const [queueCount, setQueueCount] = useState(0);
    const [countF, setCountF] = useState(0);

    // STATE AND METHODS FOR BULK ASSIGNMENT  const [bulkAssignOpen, setBulkAssignOpen] = useState(false);
    const [bulkAssignOpen, setBulkAssignOpen] = useState(false);

    const handleBulkAssignModelOpen = () => setBulkAssignOpen(true);
    const handleBulkAssignModelClose = () => setBulkAssignOpen(false);

    // EXPORT RELATED
    const [exportAllocationOpen, setExportAllocationOpen] = useState(false);
    const [exportDateRange, setExportDateRange] = useState({
        from: dayjs().format("YYYY-MM-DD"),
        to: dayjs().format("YYYY-MM-DD"),
    });
    const [exportLoading, setExportLoading] = useState(false);
    const [enableFilterOnExport, setEnableFilterOnExport] = useState(false);

    const handleExportAllocationOpen = () => {
        setExportAllocationOpen(true);
    };
    const handleExportAllocationClose = () => {
        setExportAllocationOpen(false);
    };

    const handleExportAllocation = () => {
        setExportLoading(true);
        axios
            .get(
                API_HOST_CRM +
                `/case-exporty-by-range?from=${exportDateRange.from ? exportDateRange.from : ""
                }&to=${exportDateRange.to ? exportDateRange.to : ""}`,
                {
                    responseType: "blob",
                }
            )
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `allocations_${exportDateRange.from}_to_${exportDateRange.to}.xlsx`
                );
                document.body.appendChild(link);
                link.click();
                link.remove();
                toast.success("Allocations exported successfully");
                handleExportAllocationClose();
            })
            .catch((e) => {
                console.error("Error exporting allocations:", e);
                toast.error("Error exporting allocations");
            })
            .finally(() => {
                setExportLoading(false);
            });
    };

    /**
     * This function will pass in additional query param called "mode"  which can be either "inclusive" or "exclusive"
     */
    const handleExportAllocationModded = (mode) => {
        // before we do anything
        // lets check if exportDateRange.from and exportDateRange.to is not null
        // check 1: if from or t is null
        if (!exportDateRange.from || !exportDateRange.to) {
            toast.error("Please select both from and to date");
            return;
        }

        // check 2: if from is less than to
        if (
            exportDateRange.from &&
            exportDateRange.to &&
            dayjs(exportDateRange.from).isAfter(dayjs(exportDateRange.to))
        ) {
            toast.error("From date cannot be greater than to date");
            return;
        }

        setExportLoading(true);
        axios
            .get(
                API_HOST_CRM +
                `/export-cases-by-range-aggregate?from=${exportDateRange.from ? exportDateRange.from : ""
                }&to=${exportDateRange.to ? exportDateRange.to : ""}&mode=${mode}` +
                `${filter.from
                    ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
                `${filter.lastAttemptDateFrom
                    ? `&lastAttemptDateFrom=${dayjs(
                        filter.lastAttemptDateFrom
                    ).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.lastAttemptDateTo
                    ? `&lastAttemptDateTo=${dayjs(filter.lastAttemptDateTo).format(
                        "YYYY-MM-DD"
                    )}`
                    : ""
                }` +
                `${filter.status
                    ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}`
                    : ""
                }` +
                `${filter.district
                    ? `&district=${encodeURIComponent(
                        JSON.stringify(filter.district)
                    )}`
                    : ""
                }` +
                `${filter.dataType
                    ? `&dataType=${encodeURIComponent(
                        JSON.stringify(filter.dataType)
                    )}`
                    : ""
                }` +
                // `${filter.status ? `&status=${filter.status}` : ""}` +
                // `${filter.district ? `&district=${filter.district}` : ""}` +
                `${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
                `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
                `${filter.contact ? `&contact=${filter.contact}` : ""}` +
                `${filter.previouCallStatus
                    ? `&previouCallStatus=${filter.previouCallStatus}`
                    : ""
                }` +
                `${filter.motherStatus
                    ? `&motherStatus=${encodeURIComponent(
                        JSON.stringify(filter.motherStatus)
                    )}`
                    : ""
                }` +
                // `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
                `${filter.telecaller
                    ? `&telecaller=${encodeURIComponent(
                        JSON.stringify(filter.telecaller)
                    )}`
                    : ""
                }` +
                `${filter.allocatedToUser
                    ? `&allocatedToUser=${encodeURIComponent(
                        JSON.stringify(filter.allocatedToUser)
                    )}`
                    : ""
                }` +
                `${filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
                }` +
                `${filter.date_received_from
                    ? `&date_received_from=${filter.date_received_from}`
                    : ""
                }` +
                `${filter.date_received_to
                    ? `&date_received_to=${filter.date_received_to}`
                    : ""
                }` +
                `${filter.cfrom
                    ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
                }` +
                `${filter.week ? `&week=${filter.week}` : ""}` +
                `${filter.reschedules ? `&reschedules=${filter.reschedules}` : ""}` +
                `${filter.priority
                    ? `&priority=${encodeURIComponent(
                        JSON.stringify(filter.priority)
                    )}`
                    : ""
                }` +
                `${filter.data_type ? `&data_type=${filter.data_type}` : ""}`,
                {
                    responseType: "blob",
                }
            )
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `allocations_${exportDateRange.from}_to_${exportDateRange.to}.xlsx`
                );
                document.body.appendChild(link);
                link.click();
                link.remove();
                toast.success("Allocations exported successfully");
                handleExportAllocationClose();
            })
            .catch((e) => {
                console.error("Error exporting allocations:", e);
                toast.error("Error exporting allocations");
            })
            .finally(() => {
                setExportLoading(false);
            });
    };

    const handleExportAllocationConnectivityIssue = () => {
        setExportLoading(true);
        axios
            .get(
                API_HOST_CRM +
                // `/case-exporty-by-range?from=${exportDateRange.from ? exportDateRange.from : ""
                // }&to=${exportDateRange.to ? exportDateRange.to : ""}&type=${type}`,
                // Need to change, no need of modals
                `/case-exporty-by-range?from=${filter.from ? filter.from : dayjs()
                }&to=${filter.to ? filter.to : dayjs()}&type=${type}`,
                {
                    params: {
                        filter: setEnableFilterOnExport ? { ...filter } : {},
                    },
                    responseType: "blob",
                }
            )
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `allocations_${filter.from
                        ? dayjs(filter.from).format("DD/MM/YYYY")
                        : dayjs().format("DD/MM/YYYY")
                    }_to_${filter.to
                        ? dayjs(filter.to).format("DD/MM/YYYY")
                        : dayjs().format("DD/MM/YYYY")
                    }.xlsx`
                );
                document.body.appendChild(link);
                link.click();
                link.remove();
                toast.success("Allocations exported successfully");
                handleExportAllocationClose();
            })
            .catch((e) => {
                console.error("Error exporting allocations:", e);
                toast.error("Error exporting allocations");
            })
            .finally(() => {
                setExportLoading(false);
            });
    };

    // END EXPORT RELATED

    // UPDATE DATA RELATED
    const [updateDataModalOpen, setUpdateDataModalOpen] = useState(false);
    const handleUpdateDataModalOpen = () => setUpdateDataModalOpen(true);
    const handleUpdateDataModalClose = () => setUpdateDataModalOpen(false);

    // END UPDATE DATA RELATED

    // MODAL FOR ASSIGN AUTO (NEW)
    const {
        isOpen: isAssignAutoModalOpen,
        openModal: openAssignAutoModal,
        closeModal: closeAssignAutoModal,
        data: assignAutoModalData,
        setData: setAssignAutoModalData,
    } = useModalState();
    // END MODAL FOR ASSIGN AUTO (NEW)
    const [filter, setFilter] = useState({
        from: null, // dayjs("01-01-2023"),
        to: null, //dayjs(),
        cfrom: null,
        cto: null,

        week: null,
        priority: null,
        same_contact: true,
    });

    // Loading state for markign case as bad data or completed
    const [markingCaseType, setMarkingCaseType] = useState(false);
    const [markingCaseTypeConfirmation, setMarkingCaseTypeConfirmation] =
        useState(false);
    const [fetchingCaseCanBeMovedToBadData, setFetchingCaseCanBeMovedToBadData] =
        useState(false);
    const [fetchedCaseCanBeMovedToBadData, setFetchedCaseCanBeMovedToBadData] =
        useState(null);

    const handleModalCloseEditCase = () => {
        setSelectedCase(null);
        setFetchedCaseCanBeMovedToBadData(null);
        setMarkingCaseTypeConfirmation(false);
        setMarkingCaseType(false);
        setEditOpen(false);
    };

    useEffect(() => {
        console.log("Filter: ", filter);
        // we also need to modify teh selectedRows
        // only do this when filter changes
        setStaticSelectedRows(new Map());

        // set page to 0
        setPage(0);
    }, [filter]);

    useEffect(() => {
        if (socket) {
            // this will be called when a case is allocated to some user
            socket.on("case-allocated-refresh", (socket_data) => {
                // data will be an array of case ids
                console.log("what de socket, data", socket_data);
                // remove from staticSelectedRows
                let newStaticSelectedRows = new Map(staticSelectedRows);
                setStaticSelectedRows((prevState) => {
                    // socket_data will be an object so
                    Object.keys(socket_data).forEach((caseId) => {
                        newStaticSelectedRows.delete(caseId);
                    });
                    return newStaticSelectedRows;
                });
                setData((prevState) => {
                    return prevState.map((e) => {
                        if (socket_data[e._id]) {
                            return { ...e, ...socket_data[e._id] };
                        }
                        return e;
                    });
                });
                // call debouncedGetList
                // need to only fetch the list if the current data
                // consist any of the id in the socket_data
                // loop through the data and check if any of the id is in the socket_data
                // for (let i = 0; i < data.length; i++) {
                //   // printing the log somehow makes the below line work wtf.
                //   console.log("data[i]._id", data[i]._id);
                //   if (socket_data.includes(data[i]._id)) {
                //     getList(true);
                //     break;
                //   }
                // }
            });

            // TODO: need another socket event when a telecaller updates a case using ecd form
            // check the data if it contains and call the debouncedGetList
            // This socket event is fired when a telecaller updates a case using ecd form
            socket.on("case-update", (socket_data) => {
                // so when this happens
                // loop through the data array in client side and update the case with the new data
                const newData = [...data];

                // looping through newData and for the matching _id in socket_data.case._id
                // update the case with the new data
                let containesInClientData = false;
                newData.map((client_data) => {
                    if (socket_data.case._id == client_data._id) {
                        containesInClientData = true;
                        return socket_data.case;
                    }
                    return client_data;
                });
                if (containesInClientData) {
                    setData(newData);
                }

                console.log("case-update-socket", socket_data);
                // getList(true); // this was already commented, may not need to called get list here, i don't know
                // debouncedGetList(true);
            });
        }
        return () => {
            if (socket) {
                socket.removeAllListeners();
            }
        };
    }, [socket]);

    useEffect(() => {
        console.log("Data map", dataMap);
        const dd = data.reduce((a, e) => {
            if (!(e.motherID in a)) {
                a[e.motherID] = e;
                a[e.motherID].listArray = [];
            } else {
                a[e.motherID].listArray.push(e);
            }
            return a;
        }, {});

        console.log(dd, type);
        if (grouped) {
            setGroupedData(Object.values(dd));
        } else {
            setGroupedData(data);
        }
    }, [data]);

    const getListOld = (keep) => {
        // getListGrouped(false)

        if (!keep) {
            setData([]);
        }
        console.log("-------------->", filter);
        axios
            .get(
                API_HOST_CRM +
                `/cases/same-contact-cases-today?limit=${rowsPerPage}` +
                // This is for getting grouped data and md stands for master database
                // `&md=${true}` +
                `&page=${page}&type=${type}` +
                `${filter.from
                    ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
                `${filter.lastAttemptDateFrom
                    ? `&lastAttemptDateFrom=${dayjs(
                        filter.lastAttemptDateFrom
                    ).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.lastAttemptDateTo
                    ? `&lastAttemptDateTo=${dayjs(filter.lastAttemptDateTo).format(
                        "YYYY-MM-DD"
                    )}`
                    : ""
                }` +
                `${filter.status
                    ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}`
                    : ""
                }` +
                `${filter.district
                    ? `&district=${encodeURIComponent(
                        JSON.stringify(filter.district)
                    )}`
                    : ""
                }` +
                `${filter.dataType
                    ? `&dataType=${encodeURIComponent(
                        JSON.stringify(filter.dataType)
                    )}`
                    : ""
                }` +
                // `${filter.status ? `&status=${filter.status}` : ""}` +
                // `${filter.district ? `&district=${filter.district}` : ""}` +
                `${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
                `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
                `${filter.contact ? `&contact=${filter.contact}` : ""}` +
                `${filter.previouCallStatus
                    ? `&previouCallStatus=${filter.previouCallStatus}`
                    : ""
                }` +
                `${filter.motherStatus
                    ? `&motherStatus=${encodeURIComponent(
                        JSON.stringify(filter.motherStatus)
                    )}`
                    : ""
                }` +
                // `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
                `${filter.telecaller
                    ? `&telecaller=${encodeURIComponent(
                        JSON.stringify(filter.telecaller)
                    )}`
                    : ""
                }` +
                `${filter.allocatedToUser
                    ? `&allocatedToUser=${encodeURIComponent(
                        JSON.stringify(filter.allocatedToUser)
                    )}`
                    : ""
                }` +
                `${filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
                }` +
                `${filter.date_received_from
                    ? `&date_received_from=${filter.date_received_from}`
                    : ""
                }` +
                `${filter.date_received_to
                    ? `&date_received_to=${filter.date_received_to}`
                    : ""
                }` +
                `${filter.cfrom
                    ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
                }` +
                `${filter.week ? `&week=${filter.week}` : ""}` +
                `${filter.reschedules ? `&reschedules=${filter.reschedules}` : ""}` +
                `${filter.priority
                    ? `&priority=${encodeURIComponent(
                        JSON.stringify(filter.priority)
                    )}`
                    : ""
                }` +
                `${filter.data_type ? `&data_type=${filter.data_type}` : ""}`
            )
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    // we migth have to modify it a bit since we are returning grouped data
                    /**
                     * So cases will in the shape of :
                     * [
                     *    {
                     *      count: 1,
                     *      cases: [{}],
                     *      group: "MotherID"
                     *    },
                     *    {
                     *    ...
                     *    }
                     * ]
                     *
                     * So we set the data to first index of the cases because it will be the latest one
                     */
                    // let latestCases = resp.data.cases.map((caseObject) => {
                    //   return caseObject.cases[0]; // hopefully there is this data
                    // });

                    // setDataMap((prevMap) => {
                    //   let newMap = new Map();

                    //   // loop through the cases data
                    //   resp.data.cases.forEach((cased) => {
                    //     let value = null;
                    //     if (cased.cases.length === 1) {
                    //       value = null;
                    //     } else {
                    //       value = cased.cases.slice(1);
                    //     }

                    //     newMap.set(cased.group, value);
                    //     console.log("new Map", newMap);
                    //   });
                    //   return newMap;
                    // });

                    setData(resp.data.cases);
                    // setData(latestCases);
                    setCount(resp.data.count);
                    // setCount(resp.data.count[0].total);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const getList = (keep, getCaseIds = false) => {
        if (!keep) {
            setData([]);
        }
        setListLoading(true);
        setAssignFilteredCases([]);
        console.log("-------------->", filter);
        axios
            .get(
                API_HOST_CRM +
                `/cases/same-contact-cases-today?limit=${rowsPerPage}` +
                `${getCaseIds ? "&getCaseIds=yes" : ""}` +
                // This is for getting grouped data and md stands for master database
                // `&md=${true}` +
                `&page=${page}&type=${type}` +
                `${filter.from
                    ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
                `${filter.lastAttemptDateFrom
                    ? `&lastAttemptDateFrom=${dayjs(
                        filter.lastAttemptDateFrom
                    ).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.lastAttemptDateTo
                    ? `&lastAttemptDateTo=${dayjs(filter.lastAttemptDateTo).format(
                        "YYYY-MM-DD"
                    )}`
                    : ""
                }` +
                `${filter.status
                    ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}`
                    : ""
                }` +
                `${filter.district
                    ? `&district=${encodeURIComponent(
                        JSON.stringify(filter.district)
                    )}`
                    : ""
                }` +
                `${filter.dataType
                    ? `&dataType=${encodeURIComponent(
                        JSON.stringify(filter.dataType)
                    )}`
                    : ""
                }` +
                // `${filter.status ? `&status=${filter.status}` : ""}` +
                // `${filter.district ? `&district=${filter.district}` : ""}` +
                `${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
                `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
                `${filter.contact ? `&contact=${filter.contact}` : ""}` +
                `${filter.previouCallStatus
                    ? `&previouCallStatus=${filter.previouCallStatus}`
                    : ""
                }` +
                `${filter.motherStatus
                    ? `&motherStatus=${encodeURIComponent(
                        JSON.stringify(filter.motherStatus)
                    )}`
                    : ""
                }` +
                // `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
                `${filter.telecaller
                    ? `&telecaller=${encodeURIComponent(
                        JSON.stringify(filter.telecaller)
                    )}`
                    : ""
                }` +
                `${filter.allocatedToUser
                    ? `&allocatedToUser=${encodeURIComponent(
                        JSON.stringify(filter.allocatedToUser)
                    )}`
                    : ""
                }` +
                `${filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
                }` +
                `${filter.date_received_from
                    ? `&date_received_from=${filter.date_received_from}`
                    : ""
                }` +
                `${filter.date_received_to
                    ? `&date_received_to=${filter.date_received_to}`
                    : ""
                }` +
                `${filter.upload_date_from
                    ? `&upload_date_from=${filter.upload_date_from}`
                    : ""
                }` +
                `${filter.upload_date_to
                    ? `&upload_date_to=${filter.upload_date_to}`
                    : ""
                }` +
                `${filter.cfrom
                    ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
                    : ""
                }` +
                `${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
                }` +
                `${filter.week ? `&week=${filter.week}` : ""}` +
                `${filter.reschedules ? `&reschedules=${filter.reschedules}` : ""}` +
                `${filter.priority
                    ? `&priority=${encodeURIComponent(
                        JSON.stringify(filter.priority)
                    )}`
                    : ""
                }` +
                `${filter.data_type ? `&data_type=${filter.data_type}` : ""}` +
                `${filter.attempt ? `&attempt=${filter.attempt}` : ""}`
            )
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    if (!getCaseIds) {
                        setData(resp.data.cases);
                        setCount(resp.data.data.count);
                    } else {
                        if (resp.data.caseIds) {
                            setAssignFilteredCases(resp.data.caseIds);
                            setQueueCount(resp.data.queueCount);
                        }
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setListLoading(false);
            });
    };

    useEffect(() => {
        console.log("--------------coming from filter update-------");
        // console.log("Page changes", page);
        // getList();
        debouncedGetList();
    }, [
        page,
        rowsPerPage,
        // there is an use effect for filter differently which will update the page state and run
        // this use effect
        filter,
    ]);

    // useEffect(() => {
    // getList();
    // }, []);

    const [debouncedGetList, isLoading] = useDebounce(getList, 500);

    const exportMotherReport = (data) => {
        axios
            .get(
                API_HOST_CRM +
                `/export-motherData?id=${data.motherID}&from=${encodeURIComponent(
                    dayjs(filter.from).format("YYYY-MM-DD")
                )}&to=${encodeURIComponent(dayjs(filter.to).format("YYYY-MM-DD"))}
				
				`,
                {
                    responseType: "arraybuffer",
                }
            )
            .then((resp) => {
                if (resp) {
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `Mother_Report_${data.motherID}+${data.name}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                    console.log(resp);
                    link.remove();
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const saveEditedStatus = () => {
        console.log(selectedCase);
        if (!selectedCase) {
            return;
        }
        // return
        axios
            .put(API_HOST_CRM + `/edit-cases`, {
                id: selectedCase?._id,
                status: selectedCase?.status,
            })
            .then((resp) => {
                if (resp.data?.success) {
                    const caseObj = resp.data.updatedCase;
                    const indx = data.findIndex((e) => e._id == caseObj._id);
                    console.log(indx);
                    const newData = [...data];
                    newData[indx] = caseObj;
                    setData([...newData]);
                    getList();
                }
                setEditOpen(false);
            })
            .catch((e) => {
                setEditOpen(false);
                console.log(e);
            });
    };

    /**
     * Api Method to mark a case as badData or completed
     * @param {"badData" | "completed"} caseType
     */
    const markCaseType = async (caseType) => {
        try {
            setMarkingCaseType(true);
            const result = await axios.post(API_HOST_CRM + "/mark-case-type", {
                caseId: selectedCase._id,
                type: caseType,
            });

            if (result.data.success) {
                toast.success("Case marked as " + caseType, {
                    position: "top-center",
                });

                getList();
                setEditOpen(false);
                setSelectedCase(null);
            }
        } catch (e) {
            toast.error("Error in marking case as " + caseType, {
                position: "top-center",
            });
        } finally {
            setMarkingCaseType(false);
        }
    };

    // ASSIGN CASES RELATED
    const assignSelectedCases = async () => {
        if (staticSelectedRows.size == 0) {
            toast.error("No cases selected");
            return;
        }

        const canBeAllocated = await selectedRowsThatCanBeAllocated();

        if (canBeAllocated.size > 0) {
            setNeedToBeUnassignedCases(canBeAllocated);
        } else {
            setActiveSelectedAssign("selected-agent");
            setAssignSelectedCompleted(false);
        }
    };
    // END ASSIGN CASES RELATED

    // UNASSIGN CASES RELATED
    const selectedRowsThatCanBeAllocated = async () => {
        let newNeedUnassignedMap = new Map();

        // need to loop through the staticSelectedRows,
        // make a network request

        // get the keys of staticSelectedRows
        const caseIds = Array.from(staticSelectedRows.keys());

        // need to use motherID now since we have multiple cases;
        const motherIds = caseIds.map((caseId) => {
            return staticSelectedRows.get(caseId)?.motherID;
        });

        // remove duplicate motherIds
        const uniqueMotherIds = [...new Set(motherIds)];

        // make a network request to get the details of the cases
        try {
            setIsFetchingSelectedCasesDetails(true);
            // const result = await axios.post(
            // API_HOST_CRM + "/ecd/selected-cases-details",
            // {
            // cases: caseIds,
            // }
            //);

            const result = await axios.post(
                API_HOST_CRM + "/ecd/selected-cases-details/mother-ids",
                {
                    cases: uniqueMotherIds,
                }
            );

            if (result.data.success) {
                const cases = result.data.cases;

                let newStaticSelectedRows = new Map(staticSelectedRows);

                // now loop over it
                Array.from(newStaticSelectedRows.values()).map((staticCase) => {
                    let staticSelectedCase = staticCase;
                    let staticCaseMotherId = staticSelectedCase.motherID;

                    // now we need to search through the cases if the same motherID exists and they are in queue,
                    let matchingMotherIDinQueueCase = cases.find(
                        (kase) =>
                            kase.motherID === staticCaseMotherId && kase.status === "Queue"
                    );

                    // it means the motherId of the staticSelectedCase is in queue, so what we do is first delete the case_id of the already existing one,
                    if (matchingMotherIDinQueueCase) {
                        newStaticSelectedRows.delete(staticSelectedCase._id);
                        newStaticSelectedRows.set(
                            matchingMotherIDinQueueCase._id,
                            matchingMotherIDinQueueCase
                        );
                    }
                });

                setStaticSelectedRows(newStaticSelectedRows);

                cases.forEach((e) => {
                    if (e.status !== "Queue") {
                        newNeedUnassignedMap.set(e._id, e);
                    }
                });
            }
        } catch (error) {
            toast.error("Error in fetching selected cases details");
            console.log(error);
        } finally {
            setIsFetchingSelectedCasesDetails(false);
        }

        if (newNeedUnassignedMap.size > 0) {
            setNeedToBeUnassignedCases(newNeedUnassignedMap);
            toast(`${newNeedUnassignedMap.size} rows need to be unallocated `);
        }

        return newNeedUnassignedMap;
    };

    const unassignSelectedRows = async () => {
        setIsUnassigning(true);

        // replace it with a new api or use the same
        const resp = await axios
            .put(API_HOST_CRM + "/ecd/unassign-pendings", {
                caseIds: Array.from(needToBeUnassignedCases.keys()),
                reason: "66b1a4f1999b4aa3b0a6e170",
            })
            .catch((e) => {
                console.log(e);
                toast.error("Network Request Error in unassigning cases");
                setIsUnassigning(false);
            });

        console.log("what is the response", resp);
        if (resp.data && resp.data.success) {
            getList(true);

            toast.success(`${needToBeUnassignedCases.size} cases unallocated`, {
                position: "top-center",
                duration: 3800,
            });
            toast.success("Unassigned Successfully", {
                position: "top-center",
                duration: 3800,
            });
            setNeedToBeUnassignedCases(new Map());
            let newStaticSelectedRows = new Map(staticSelectedRows);

            // We are expecting newCreatedCases in the resp.data
            const newCreatedCases = resp.data.newCreatedCases;
            if (!newCreatedCases) {
                toast.error("Data not received. Error in unassigning cases", {
                    position: "top-center",
                    duration: 3800,
                });
                setIsUnassigning(false);
                return;
            }

            // now we need to loop over the newStaticSelectedRows
            Array.from(newStaticSelectedRows.values()).forEach((item) => {
                // check if the item is in the newCreatedCases
                const matchingCase = newCreatedCases.find(
                    (c) => c.motherID === item.motherID
                );
                if (matchingCase) {
                    newStaticSelectedRows.delete(item._id);
                    newStaticSelectedRows.set(matchingCase._id, matchingCase);
                }
            });

            // The logic has changed a bit we are creating new cases with the same data but updated
            // state and status
            // so need to get the data from the response and update the staticSelectedRows
            // with the new data

            // now we need to loop over selectedRows and update the state and status to "Unalloted" and "Queue"
            // Array.from(needToBeUnassignedCases.keys()).forEach((e) => {
            //   if (staticSelectedRows.has(e)) {
            //     let newUpdatedRow = {
            //       ...staticSelectedRows.get(e),
            //       allocatedToUser: null,
            //       callDate: null,
            //       allocatedTo: null,
            //       state: "Unalloted",
            //       // dataType: "olddata",
            //       status: "Queue",
            //       unassigned: true,
            //       unAssignedOn: new Date(),
            //       unAssignedBy: user._id,
            //       unassignReason: "66b1a4f1999b4aa3b0a6e170",
            //     };
            //     newStaticSelectedRows.set(e, newUpdatedRow);
            //   }
            // });
            setStaticSelectedRows(newStaticSelectedRows);
        }
        setIsUnassigning(false);
    };

    const handleRemoveStaticSelection = (id, motherID) => {
        console.log("what is the id to be removed", id);

        // let newStaticSelectedRows = new Map(staticSelectedRows);
        // newStaticSelectedRows.delete(id);
        // console.log("what the statci rows before", staticSelectedRows);
        // console.log("how many times being called from active.js", id);
        // setStaticSelectedRows(newStaticSelectedRows);
        setStaticSelectedRows((prevStaticSelectedRows) => {
            console.log("is this state updating");
            const newStaticSelectedRows = new Map(prevStaticSelectedRows);

            // here we were using caseid but there will be multiple cases
            // so it would be better to use motherID
            // SO here we will find the motherid out of the staticSelectedRows
            const matchingCase = Array.from(newStaticSelectedRows.values()).filter(
                (data) => {
                    return data.motherID === motherID;
                }
            );

            if (matchingCase.length === 0) {
                return newStaticSelectedRows;
            }

            // Delete the specified ID from the new Map
            // newStaticSelectedRows.delete(id);
            newStaticSelectedRows.delete(matchingCase[0]?._id);
            // console.log("what the static rows before", prevStaticSelectedRows);
            // console.log("how many times being called from active.js", id);
            // Return the updated Map to set the new state
            return newStaticSelectedRows;
        });
    };

    /**
     * Method to fetch a case
     * keep in mind this route should first fetch the latest case
     * @param {object} caseData
     */
    const fetchCase = async (caseData) => {
        try {
            setFetchingCaseCanBeMovedToBadData(true);
            const result = await axios.get(
                API_HOST_CRM + `/case/${caseData.motherID}`
            );
            if (result.data.success) {
                setFetchedCaseCanBeMovedToBadData(result.data.case);
            }
        } catch (e) {
            toast.error("Error in fetching case", {
                position: "top-center",
                duration: 1400,
            });
        } finally {
            setFetchingCaseCanBeMovedToBadData(false);
        }
    };

    /**
     * Method to be in the confirmation stage for moving a case to bad data
     *
     */
    const toggleMarkingCaseTypeConfirmationStage = (caseData) => {
        if (markingCaseTypeConfirmation) {
            setMarkingCaseTypeConfirmation(false);
        } else {
            setMarkingCaseTypeConfirmation(true);
            fetchCase(caseData);
        }
    };

    // END UNASSIGN CASES RELATED

    /**
     * Method to move a case to bad data
     */

    // use effect to show a toast regarding how many duplicate cases were there while selected
    useEffect(() => {
        if (openAssignSelected) {
            // filter out the staticSelectedRows to contain unique values based on created at
            // Filter out duplicate entries based on motherID from staticSelectedRows
            const uniqueStaticSelectedRows = Array.from(
                staticSelectedRows.values()
            ).reduce((uniqueRows, currentRow) => {
                // Check if we already have an entry with this motherID
                const existingRowIndex = uniqueRows.findIndex(
                    (row) => row.motherID === currentRow.motherID
                );

                // If no existing entry found, add the current row
                if (existingRowIndex === -1) {
                    return [...uniqueRows, currentRow];
                }

                // If duplicate found, compare createdAt dates and keep the latest one
                const existingDate = new Date(uniqueRows[existingRowIndex].createdAt);
                const currentDate = new Date(currentRow.createdAt);

                if (currentDate > existingDate) {
                    // Replace existing entry with current row since it's newer
                    uniqueRows[existingRowIndex] = currentRow;
                }

                return uniqueRows;
            }, []);

            // now with the uniqueStaticSelectedRows we will update the staticSelectedRows
            const newStaticSelectedRows = new Map();

            uniqueStaticSelectedRows.forEach((row) => {
                newStaticSelectedRows.set(row._id, row);
            });

            let difference =
                staticSelectedRows.size - uniqueStaticSelectedRows.length;

            let showToast = difference > 0;

            let toastMessage = showToast
                ? `${difference} duplicate were removed.
      `
                : `No duplicates found.`;

            toast(`${toastMessage}`, {
                position: "top-center",
                duration: 2000,
            });

            setStaticSelectedRows(newStaticSelectedRows);

            console.log(uniqueStaticSelectedRows, "uniqueStaticSelectedRows");
        }
    }, [openAssignSelected]);

    console.log(filter, "filter");
    console.log(
        removeNullValueFromObject(filter),
        "removeNullValueFromObject(filter)"
    );
    console.log(
        Object.values(removeNullValueFromObject(filter)).length,
        "Object.values(removeNullValueFromObject(filter)).length"
    );

    return (
        <>
            <ToolbarWrapper>
                <ToolBar
                    name={heading}
                    height={"3em"}
                    buttons={[
                        ...(type === "active"
                            ? [
                                // {
                                //   name: assignCompleted
                                //     ? "Assign Completed"
                                //     : assigning
                                //       ? "Assigning....."
                                //       : "Assign Auto",
                                //   // type: 'chip',
                                //   icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
                                //   onClick: () => {
                                //     if (!assigning && !assignCompleted) {
                                //       setAssigning(true);
                                //       axios
                                //         .get(API_HOST_CRM + "/allocate-auto")
                                //         .then((resp) => {
                                //           if (resp.data && resp.data.success) {
                                //             setAssigning(false);
                                //             setAssignCompleted(true);
                                //             setTimeout(() => {
                                //               setAssignCompleted(false);
                                //             }, 2000);
                                //           }
                                //           setAssigning(false);
                                //           // new code
                                //           setStaticSelectedRows(new Map());
                                //         })
                                //         .catch((e) => {
                                //           console.log(e);
                                //           setAssigning(false);
                                //         });
                                //     }
                                //   },
                                // },
                                // {
                                //   name: "Assign Auto Filtered",
                                //   // type: 'chip',
                                //   // disable: Object.values(filter).filter(e => {
                                //   //   console.log(e)
                                //   //   return e != null
                                //   // }).length < 2,
                                //   disable: Object.values(removeNullValueFromObject(filter)).length < 2,
                                //   icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
                                //   onClick: () => {
                                //     setAssigningFilteredState(false)
                                //     setAssignOverview(null)
                                //     setCountF(count)
                                //     setQueueCount(0)
                                //     setAssignFilteredCases([])
                                //     setOpenAssignAutoFiltered(true)
                                //     getList(true, true)
                                //   },
                                // },
                                {
                                    name: "Assign Auto",
                                    // type: 'chip',
                                    // disable: Object.values(filter).filter(e => {
                                    //   console.log(e)
                                    //   return e != null
                                    // }).length < 2,
                                    // disable: Object.values(removeNullValueFromObject(filter)).length < 2,
                                    icon: () => <BoltIcon sx={{ fontSize: "1.2em" }} />,
                                    onClick: () => {
                                        // setAssigningFilteredState(false)
                                        // setAssignOverview(null)
                                        // setCountF(count)
                                        // setQueueCount(0)
                                        // setAssignFilteredCases([])
                                        // setOpenAssignAutoFiltered(true)
                                        openAssignAutoModal();
                                        getList(true, true);
                                    },
                                },
                                // {
                                //   name: `Assign (${selectedRows.length}) Selected`,
                                //   disable: selectedRows.length == 0,
                                //   // type: 'chip',
                                //   icon: () => <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} />,
                                //   onClick: () => {
                                //     if (true) {
                                //       setAssignSelectedCompleted(false);
                                //       setOpenAssignSelected(true);
                                //       setActiveSelectedAssign(null);
                                //     }
                                //   },
                                // },
                                {
                                    name: `Assign (${staticSelectedRows.size}) Selected`,
                                    disable: staticSelectedRows.size == 0,
                                    // type: 'chip',
                                    icon: () => <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} />,
                                    onClick: () => {
                                        if (true) {
                                            setAssignSelectedCompleted(false);
                                            setOpenAssignSelected(true);
                                            setActiveSelectedAssign(null);
                                        }
                                    },
                                },
                                // {
                                //   name: `Bulk Assign`,
                                //   onClick: () => {
                                //     // open the bulk assign modal
                                //     handleBulkAssignModelOpen();
                                //   },
                                // },
                                // {
                                //     name: exportLoading ? `Exporting...` : `Export Allocations`,
                                //     icon: () => <IosShareOutlined sx={{ fontSize: "1.2em" }} />,
                                //     onClick: () => {
                                //         handleExportAllocationOpen();
                                //         // handleExportAllocationConnectivityIssue();
                                //     },
                                // },
                                // {
                                //   name: "Update Data",
                                //   icon: () => <IosShareOutlined sx={{ fontSize: "1.2em" }} />,
                                //   onClick: () => {
                                //     handleUpdateDataModalOpen();
                                //   },
                                // },
                            ]
                            : []),
                        ...(type === "connectivity-issue"
                            ? [
                                {
                                    name: "Export Allocations",
                                    icon: () => <IosShareOutlined sx={{ fontSize: "1.2em" }} />,
                                    onClick: () => {
                                        handleExportAllocationOpen();
                                    },
                                },
                                {
                                    name: `Assign (${staticSelectedRows.size}) Selected`,
                                    disable: staticSelectedRows.size == 0,
                                    // type: 'chip',
                                    icon: () => <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} />,
                                    onClick: () => {
                                        if (true) {
                                            setAssignSelectedCompleted(false);
                                            setOpenAssignSelected(true);
                                            setActiveSelectedAssign(null);
                                        }
                                    },
                                },
                            ]
                            : []),
                        ...(type === "schedule-later"
                            ? [
                                {
                                    name: `Assign (${staticSelectedRows.size}) Selected`,
                                    disable: staticSelectedRows.size == 0,
                                    // type: 'chip',
                                    icon: () => <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} />,
                                    onClick: () => {
                                        if (true) {
                                            setAssignSelectedCompleted(false);
                                            setOpenAssignSelected(true);
                                            setActiveSelectedAssign(null);
                                        }
                                    },
                                },
                            ]
                            : []),
                    ]}
                    onClearFilter={() => {
                        setFilter({
                            lastAttemptDateFrom: null,
                            lastAttemptDateTo: null,
                            from: null,
                            to: null,
                            cfrom: null,
                            cto: null,
                            firstReceived: null,
                            motherName: "",
                            motherID: "",
                            contact: "",
                            status: null,
                            motherStatus: null,
                            telecaller: null,
                            district: null,
                            upload_date_from: null,
                            upload_date_to: null,
                        });
                    }}
                    filters={[
                        ...(type === "connectivity-issue"
                            ? [
                                // type of call
                                {
                                    minWidth: 150,
                                    field: {
                                        name: "typeOfIssue",
                                        type: "select",
                                        label: "Type of Call Issue",
                                        option: {
                                            key: "TypeOfCallIssue",
                                            value: "_id",
                                            label: "name",
                                        },
                                        noMb: true,
                                    },
                                    data: {
                                        TypeOfCallIssue: [
                                            "Any",
                                            "No Answer",
                                            "Out Of Service",
                                            "Switched Off",
                                            "Incoming Not Available",
                                            "Call Incomplete",
                                            "ASHA / ANM",
                                        ].map((d) => ({ _id: d, name: d })),
                                    },
                                    onChange: (name, value) => {
                                        filter[name] = value;
                                        console.log("-------------------------------->33");
                                        setFilter({ ...filter });
                                    },
                                    state: filter,
                                },
                            ]
                            : []),
                        {
                            minWidth: 150,
                            field: {
                                name: "data_type",
                                type: "select",
                                label: "Data Type",
                                option: {
                                    key: "DataTypes",
                                    value: "_id",
                                    label: "name",
                                },
                                noMb: true,
                            },
                            data: {
                                DataTypes: [
                                    { _id: "any", name: "Any" },
                                    // Data type renaming
                                    {
                                        _id: "new_data_current_month",
                                        name: "New Data Current Month",
                                    },
                                    {
                                        _id: "new_data_current_month_delivered",
                                        name: "New Data Current Month Delivered",
                                    },
                                    {
                                        _id: "previous_months_unreached_calls",
                                        name: "Previous Month Unreached Calls",
                                    },
                                    {
                                        _id: "previous_months_pending_calls",
                                        name: "Previous Month Pending Calls",
                                    },
                                    {
                                        _id: "followup_calls",
                                        name: "Followup Calls"
                                    }
                                    // {
                                    //     _id: "followup_calls_40_days",
                                    //     name: "Follow-up Calls 40 Days",
                                    // },
                                    // {
                                    //     _id: "followup_calls_90_days",
                                    //     name: "Follow-up Calls 90 Days",
                                    // }
                                    // End Data type renaming
                                    // Not removing the comments because i am petty. This is suppose to be in "production". WHAT A MESS, BOTH THIS PROJECT AND THE PEOPLE WHO WERE MANAGING IT.
                                    // { _id: "followup_calls", name: "Follow-up calls" },
                                    // // { _id: "followup_calls_delivered", name: "Follow-up calls(Delivered)" },
                                    // { _id: "new_data", name: "New Data" },
                                    // {
                                    //   _id: "previously_unreached",
                                    //   name: "Previously Unreached from previous months",
                                    // },
                                    // {
                                    //   _id: "previously_unattempted",
                                    //   name: "Previously Pending from previous months",
                                    // },
                                    // { _id: "delivered", name: "Delivered(Current Month)" },
                                    // {
                                    //   _id: "previously_delivered",
                                    //   name: "Delivered(Not Current Month)",
                                    // },
                                    // {
                                    //   _id: "previously_unreached_delivered",
                                    //   name: "Previously Unreached from previous months(Delivered)",
                                    // },
                                    // {
                                    //   _id: "previously_unattempted_delivered",
                                    //   name: "Previously Pending from previous months(Delivered)",
                                    // },
                                    // {
                                    //   _id: "followup_calls_delivered",
                                    //   name: "Followup calls(Delivered)",
                                    // },
                                ],
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                console.log("-------------------------------->33");
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                        {
                            minWidth: 150,
                            field: {
                                name: "reschedules",
                                type: "select",
                                label: "Show Reschedules",
                                option: {
                                    key: "Reschedules",
                                    value: "_id",
                                    label: "name",
                                },
                                noMb: true,
                            },
                            data: {
                                Reschedules: ["Any", "Yes", "No"].map((d) => ({
                                    _id: d,
                                    name: d,
                                })),
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                console.log("-------------------------------->33");
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                        {
                            field: {
                                name: "from",
                                type: "date",
                                label: "Assign From",
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                console.log("-------------------------------->22");
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                        {
                            field: {
                                name: "to",
                                type: "date",
                                label: "Assign To",
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                console.log("-------------------------------->11");
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                        {
                            field: {
                                name: "date_received_from",
                                type: "date",
                                label: "Date Received From",
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                        {
                            field: {
                                name: "date_received_to",
                                type: "date",
                                label: "Date Received To",
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                        {
                            field: {
                                name: "lastAttemptDateFrom",
                                type: "date",
                                label: "Last Call From",
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                console.log("-------------------------------->22");
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                        {
                            field: {
                                name: "lastAttemptDateTo",
                                type: "date",
                                label: "Last Call To",
                            },
                            onChange: (name, value) => {
                                filter[name] = value;
                                console.log("-------------------------------->11");
                                setFilter({ ...filter });
                            },
                            state: filter,
                        },
                    ]}
                />
            </ToolbarWrapper>

            {/* TO SHOW THE COUNT */}
            {/* <Typography variant="h5" sx={{ color: "#375674" }}>
        {selectedRows.length} ok and {staticSelectedRows.size} static
      </Typography> */}
            <Box sx={{ mt: 0 }}>
                <Grid
                    isLoading={listLoading}
                    grouped={grouped}
                    setStaticSelectedRows={setStaticSelectedRows}
                    staticSelectedRows={staticSelectedRows}
                    data={groupedData}
                    onSelectChange={(selected) => {
                        // console.log(selected, "how many times will i be called");
                        setSelectedRows(selected);
                    }}
                    columns={[
                        ...filterColumns(
                            [
                                {
                                    id: "requiredAllocatedToUser",
                                    showFilter: false,
                                    // type: "select",
                                },
                                {
                                    id: "motherID",
                                    showFilter: true,
                                },
                                {
                                    id: "name",
                                    showFilter: true,
                                },
                                {
                                    id: "contact",
                                    showFilter: true,
                                },
                                {
                                    id: "districtName",
                                    showFilter: true,
                                    type: "select",
                                },

                                // attempt
                                {
                                    id: "attempt",
                                    showFilter: true,
                                },
                                {
                                    id: "dateReceived",
                                    showFilter: true,
                                },
                                {
                                    id: "lastCallDate",
                                    showFilter: true,
                                },

                                {
                                    id: "allocatedToUser",
                                    // showFilter: true,
                                    isSelect: true,
                                },
                                {
                                    id: "callDate",
                                    showFilter: false,
                                },

                                ...(type == "active"
                                    ? [
                                        {
                                            id: "status",
                                            showFilter: true,
                                            type: "select",
                                        },
                                        {
                                            id: "previouCallStatus",
                                            showFilter: true,
                                            type: "select",
                                        },
                                        {
                                            id: "motherStatus",
                                            showFilter: true,
                                            type: "select",
                                        },

                                        {
                                            id: "nextCallDue",
                                            showFilter: false,
                                        },
                                    ]
                                    : []),
                                ...(type == "connectivity-issue"
                                    ? [
                                        //lastAttempt Date
                                        {
                                            id: "lastAttemptDate",
                                            showFilter: false,
                                        },
                                        {
                                            id: "status",
                                            showFilter: true,
                                            type: "select",
                                        },
                                        {
                                            id: "nextCallDue",
                                            showFilter: false,
                                        },
                                        {
                                            id: "priority",
                                            showFilter: true,
                                            type: "select",
                                        },
                                    ]
                                    : []),
                            ],
                            filter,
                            setFilter,
                            { Districts, users, map }
                        ),
                    ]}
                    groupedColumns={[
                        {
                            id: "motherID",
                            type: "string",
                            sx: {
                                minWidth: "200px",
                                maxWidth: "fit-content",
                            },
                        },
                        {
                            id: "name",
                            type: "sring",
                            sx: {
                                minWidth: "200px",
                                maxWidth: "fit-content",
                            },
                        },
                        {
                            id: "status",
                            type: "string",
                            sx: {
                                minWidth: "200px",
                                maxWidth: "fit-content",
                            },
                        },
                        {
                            id: "allocatedToUser",
                            type: "string",
                            sx: {
                                minWidth: "200px",
                                maxWidth: "max-content",
                            },
                            render: (data) => {
                                return map?.users?.[data]?.name || "";
                            },
                        },
                        {
                            id: "callDate",
                            type: "date",
                            sx: {
                                minWidth: "200px",
                                maxWidth: "fit-content",
                            },
                        },
                        {
                            id: "_id",
                            type: "string",
                            sx: {
                                minWidth: "200px",
                                maxWidth: "fit-content",
                            },
                        },
                    ]}
                    pagination={{
                        rowsPerPageOptions: [10, 25, 50, 100, 200],
                        page,
                        rowsPerPage,
                        onPageChange: (event, newPage) => {
                            setPage(newPage);
                        },
                        onRowsPerPageChange: (event) => {
                            setRowsPerPage(+event.target.value);
                            setPage(0);
                        },
                        count,
                    }}
                    actions={[
                        ...(user?.roles?.includes(process.env.REACT_APP_ADMIN)
                            ? [
                                {
                                    name: "Edit",
                                    new: true,
                                    onClick: (id) => {
                                        setEditOpen(true);
                                        setSelectedCase(data[id]);
                                    },
                                },
                            ]
                            : []),
                        {
                            name: "Details",
                            new: true,
                            onClick: (id) => {
                                history.push(
                                    `/lead/call-data/case-details/${data[id]?.motherID}`
                                );
                            },
                        },
                    ]}
                ></Grid>
            </Box>
            {/* Sankalp Related Modal */}
            <Modal
                open={open}
                handleClose={() => {
                    setOpen(false);
                }}
                head={`Sankalp Data`}
                buttons={[
                    {
                        name: "Cancel",
                        onClick: () => {
                            setOpen(false);
                        },
                    },
                ]}
            >
                {selectedSankalpData &&
                    selectedSankalpData.sankalpData &&
                    Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
                        const map = {
                            pregStatus: "Pregnancy Status",
                            advice: "Advice",
                            pregnancyNumber: "Pregnancy Number",
                            pretermDelivery: "Pre-term Delivery",
                            nearResidance: "Near By Residence",
                            trimester: "Trimester",
                        };
                        return (
                            <Box key={i} sx={{ display: "flex", mt: 1 }}>
                                <Typography variant="p">{map[s] || s}: </Typography>&nbsp;
                                <Typography
                                    variant="p"
                                    sx={{ color: "grey", fontSize: ".9em" }}
                                >
                                    {selectedSankalpData.sankalpData[s]}
                                </Typography>
                            </Box>
                        );
                    })}
            </Modal>

            {/* Assign Auto MOdal */}
            {isAssignAutoModalOpen && (
                <AutoAssignDialogFull
                    open={isAssignAutoModalOpen}
                    handleClose={closeAssignAutoModal}
                    data={assignAutoModalData}
                    setData={setAssignAutoModalData}
                    staticSelectedRows={staticSelectedRows}
                    handleRemoveStaticSelection={handleRemoveStaticSelection}
                    filter={filter}
                />
            )}
            {/* End Assign Auto MOdal */}

            {/* 
      <Modal
        open={openAssignSelected}
        handleClose={() => {
          setOpenAssignSelected(false);
        }}
        // head={`Assign selected (${selectedRows.length}) cases`}
        head={`Assign selected (${staticSelectedRows.size}) cases`}
        buttons={[
          {
            name: "Close",
            onClick: () => {
              setOpenAssignSelected(false);
            },
          },
        ]}
      // styleA={"md"}
      >
        <Box>
          {!activeSelectedAssign && (
            <Stack direction={"column"} spacing={2}>
              <Stack direction={"row"} spacing={2}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    assignSelectedCases();
                  }}
                  size="small"
                  sx={{ width: "max-content", ml: 1 }}
                >
                  <ArrowOutwardIcon sx={{ fontSize: "1.2em" }} /> &nbsp;
                  {isFetchingSelectedCasesDetails
                    ? "Fetching..."
                    : "Assign to selected agent"}
                </Button>
              </Stack>
              {needToBeUnassignedCases.size > 0 && (
                <NeedUnassignedList
                  data={needToBeUnassignedCases}
                  setData={setNeedToBeUnassignedCases}
                  handleBack={() => {
                    setNeedToBeUnassignedCases(new Map());
                  }}
                  unassign={unassignSelectedRows}
                  unassigning={isUnassigning}
                  onRemoveCaseSelection={handleRemoveStaticSelection}
                />
              )}
              {needToBeUnassignedCases.size == 0 && (
                <SelectedCasesList
                  staticSelectedRows={staticSelectedRows}
                  setStaticSelectedRows={setStaticSelectedRows}
                />
              )}
            </Stack>
          )}
          {activeSelectedAssign == "agent-auto" && (
            <Box>
              <Typography>
                {assignSelectedCompleted
                  ? "Assign Completed"
                  : assigningSelected
                    ? "Assigning....."
                    : ""}
              </Typography>
            </Box>
          )}
          {activeSelectedAssign == "selected-agent" && (
            <Box
              sx={{ ...(assigningSelected ? { pointerEvents: "none" } : {}) }}
            >
              <Box sx={{ mb: 1 }}>
                <Box
                  sx={{ cursor: "pointer", width: "fit-content" }}
                  onClick={() => {
                    setActiveSelectedAssign(null);
                  }}
                >
                  <ArrowBackIcon sx={{ fontSize: "1.2em" }} /> &nbsp;Back
                </Box>
              </Box>
              <Box sx={{ pl: 2 }}>
                <Box
                  sx={{
                    mb: 2,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    Select Agents
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    {`selected (${Object.values(selectedAgents).length})`}
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setAssigningSelected(true);

                        console.log("before assigning", staticSelectedRows);

                        axios
                          .post(API_HOST_CRM + "/allocate-selected-selected", {
                            // cases: selectedRows.map((n) => n._id),

                            cases: Array.from(staticSelectedRows.values()).map(
                              (n) => n._id,
                            ),

                            agents: Object.values(selectedAgents).map(
                              (a) => a._id,
                            ),
                          })
                          .then((resp) => {
                            if (resp.data && resp.data.success) {
                              setAssigningSelected(false);
                              setAssignSelectedCompleted(true);
                              setStaticSelectedRows(new Map());
                              getList(true);
                            } else {
                              setAssigningSelected(false);
                            }
                          })
                          .catch((e) => {
                            setAssigningSelected(false);
                            console.log(e);
                          });
                      }}
                      size="small"
                      sx={{ width: "max-content", ml: 1 }}
                    >
                      <DoubleArrowIcon sx={{ fontSize: "1.2em" }} /> &nbsp;
                      {assignSelectedCompleted
                        ? "Assign Completed"
                        : assigningSelected
                          ? "Assigning....."
                          : "Assign"}
                    </Button>
                  </Box>
                </Box>
                {Array.isArray(users) &&
                  users
                    .filter((u) =>
                      (u.roles || []).includes(
                        process.env.REACT_APP_TELECALLER,
                      ),
                    )
                    .map((u, i) => {
                      return (
                        <ListItem key={i} disablePadding>
                          <ListItemButton>
                            <Checkbox
                              checked={!!selectedAgents[u._id]}
                              onChange={(e) => {
                                let obj = { ...selectedAgents };
                                if (e.target.checked) {
                                  obj[u._id] = u;
                                } else {
                                  if (obj[u._id]) {
                                    delete obj[u._id];
                                  }
                                }
                                setSelectedAgents(obj);
                              }}
                            />{" "}
                            <ListItemText
                              primaryTypographyProps={{ fontSize: ".8em" }}
                              primary={`${u.name}`}
                              onClick={() => {
                                // addUserToShift(u._id);
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
              </Box>
            </Box>
          )}
        </Box>
      </Modal> */}
            {openAssignSelected && (
                <SelectedAssignDialog
                    open={openAssignSelected}
                    handleClose={() => {
                        setOpenAssignSelected(false);
                    }}
                    staticSelectedRows={staticSelectedRows}
                    setStaticSelectedRows={setStaticSelectedRows}
                    activeSelectedAssign={activeSelectedAssign}
                    setActiveSelectedAssign={setActiveSelectedAssign}
                    assignSelectedCases={assignSelectedCases}
                    isFetchingSelectedCasesDetails={isFetchingSelectedCasesDetails}
                    needToBeUnassignedCases={needToBeUnassignedCases}
                    setNeedToBeUnassignedCases={setNeedToBeUnassignedCases}
                    unassignSelectedRows={unassignSelectedRows}
                    isUnassigning={isUnassigning}
                    handleRemoveStaticSelection={handleRemoveStaticSelection}
                    assignSelectedCompleted={assignSelectedCompleted}
                    assigningSelected={assigningSelected}
                    setAssigningSelected={setAssigningSelected}
                    setAssignSelectedCompleted={setAssignSelectedCompleted}
                    selectedAgents={selectedAgents}
                    setSelectedAgents={setSelectedAgents}
                    users={users}
                    getList={getList}
                />
            )}

            {/* Edit a case dialog */}
            <Modal
                open={editOpen}
                handleClose={() => {
                    handleModalCloseEditCase();
                }}
                head={`Edit Case`}
                buttons={[
                    {
                        name: "Close",
                        onClick: () => {
                            handleModalCloseEditCase();
                        },
                    },
                    ...(!["Active", "Queue", "Pending"].includes(selectedCase?.status)
                        ? [
                            {
                                name: "Save",
                                onClick: () => {
                                    saveEditedStatus();
                                },
                            },
                        ]
                        : []),
                ]}
            >
                <Box sx={{ mt: 2 }}>
                    <Box sx={{ p: 2, mb: 2 }}>
                        <Typography>ID: {selectedCase?.motherID}</Typography>
                        <Typography>Name: {selectedCase?.name}</Typography>
                        {selectedCase?.callDate && (
                            <Typography>
                                CallDate: {dayjs(selectedCase?.callDate).format("DD-MM-YYYY")}
                            </Typography>
                        )}
                        <Typography>CurrentStatus: {selectedCase?.status}</Typography>
                    </Box>
                    {selectedCase &&
                        !["Active", "Queue", "Pending"].includes(selectedCase.status) && (
                            <SelectA
                                field={{
                                    type: "select",
                                    label: "Update Status",
                                    option: { key: "Status", value: "_id", label: "name" },
                                    name: "status",
                                }}
                                data={{
                                    Status: [
                                        "No answer",
                                        "Call done",
                                        "Busy",
                                        "No network",
                                        "Invalid",
                                        "Incoming not available",
                                        "Not in the portal",
                                        "Miscarriage",
                                        "Call Incomplete",
                                        "Deceased Child",
                                        "Switched off",
                                        "Wrong number",
                                        "Declined",
                                        "Out of service",
                                        "Language Barrier",
                                        "Deceased Mother",
                                        "Deceased (Mother and Child)",
                                        "Duplicate Mother Id",
                                        "Child Above 2 Years",
                                        // "Completed",
                                    ].map((d) => ({ _id: d, name: d })),
                                }}
                                onChange={(name, value, multiple) => {
                                    setSelectedCase({ ...selectedCase, status: value });
                                }}
                                value={selectedCase?.status}
                            />
                        )}
                    {["Active", "Queue", "Pending"].includes(selectedCase?.status) && (
                        <Typography sx={{ color: "red" }}>
                            Cannot edit "{selectedCase?.status}" status.
                        </Typography>
                    )}
                    {/* Move to bad data */}
                    <Stack
                        component={Paper}
                        direction={"column"}
                        spacing={1}
                        sx={{ p: 2 }}
                    >
                        <Stack direction={"row"} spacing={1}>
                            <Button
                                variant="contained"
                                color="error"
                                disabled={markingCaseType || markingCaseTypeConfirmation}
                                onClick={() => {
                                    toggleMarkingCaseTypeConfirmationStage(selectedCase);
                                }}
                            >
                                Move to Bad Data
                            </Button>
                            <Stack direction={"row"} spacing={1}>
                                {fetchingCaseCanBeMovedToBadData ? "Fetching..." : ""}
                                {fetchedCaseCanBeMovedToBadData && (
                                    <Stack direction={"row"} spacing={1}>
                                        <Typography>
                                            Status: {fetchedCaseCanBeMovedToBadData.status}
                                        </Typography>
                                        <Typography>
                                            Still pending:{" "}
                                            {fetchedCaseCanBeMovedToBadData.status == "Pending"
                                                ? "Yes"
                                                : "No"}
                                        </Typography>
                                        <Typography>
                                            Call Date:{" "}
                                            {dayjs(fetchedCaseCanBeMovedToBadData.callDate).format(
                                                "DD-MM-YYYY"
                                            )}
                                        </Typography>
                                        <Typography>
                                            Same day assigned:{" "}
                                            {dayjs().isSame(
                                                dayjs(fetchedCaseCanBeMovedToBadData.callDate),
                                                "day"
                                            )
                                                ? "Yes"
                                                : "No"}
                                        </Typography>
                                    </Stack>
                                )}
                            </Stack>
                        </Stack>
                        {markingCaseTypeConfirmation && fetchedCaseCanBeMovedToBadData && (
                            <Stack direction={"row"} spacing={1}>
                                <Typography>
                                    {dayjs().isSame(
                                        dayjs(fetchedCaseCanBeMovedToBadData.callDate),
                                        "day"
                                    ) && fetchedCaseCanBeMovedToBadData.status == "Pending"
                                        ? "Cannot move to bad data as it has already been assigned today."
                                        : "Can move to bad data"}
                                </Typography>
                                <Button
                                    disabled={
                                        markingCaseType ||
                                        (dayjs().isSame(
                                            dayjs(fetchedCaseCanBeMovedToBadData.callDate),
                                            "day"
                                        ) &&
                                            fetchedCaseCanBeMovedToBadData.status == "Pending")
                                    }
                                    variant="contained"
                                    color="success"
                                    onClick={() => {
                                        // setMarkingCaseTypeConfirmation(false);
                                        markCaseType("badData");
                                    }}
                                >
                                    Confirm
                                </Button>
                                <Button
                                    disabled={markingCaseType}
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                        setMarkingCaseTypeConfirmation(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Stack>
                        )}
                    </Stack>
                </Box>
            </Modal>

            <BulkModalAssign
                bulkAssignOpen={bulkAssignOpen}
                handleBulkAssignModelClose={handleBulkAssignModelClose}
            />
            {/* <MuiModal
        open={exportAllocationOpen}
        onClose={handleExportAllocationClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={centeredMuiModalStyle}>
          <IconButton
            aria-label="close"
            onClick={handleExportAllocationClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="modal-title" variant="h6" component="h2">
            Export Allocations
          </Typography>
          <Stack
            direction="column"
            spacing={2}
            sx={{
              p: 2,
              border: "2px solid #e0e0e0",
              borderRadius: 2,
            }}
          >
            <Stack direction="column">
              <Typography>Select Date Range</Typography>
              <Stack direction="row" spacing={2} justifyContent="center" pt={1}>
                <TextField
                  label="From"
                  type="date"
                  value={exportDateRange.from}
                  onChange={(e) => {
                    setExportDateRange({
                      ...exportDateRange,
                      from: e.target.value,
                    });
                  }}
                />
                <TextField
                  label="To"
                  type="date"
                  value={exportDateRange.to}
                  onChange={(e) => {
                    setExportDateRange({
                      ...exportDateRange,
                      to: e.target.value,
                    });
                  }}
                />
              </Stack>
            </Stack>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                onClick={handleExportAllocationConnectivityIssue}
                variant="contained"
                disabled={exportLoading}
              >
                {exportLoading ? "Exporting..." : "Export"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </MuiModal> */}
            <ExportAllocations
                exportAllocationOpen={exportAllocationOpen}
                exportLoading={exportLoading}
                handleExportAllocationClose={handleExportAllocationClose}
                // onExport={handleExportAllocationConnectivityIssue}
                onExport={handleExportAllocation}
                onModdedExport={handleExportAllocationModded}
                exportDateRange={exportDateRange}
                setExportDateRange={setExportDateRange}
                enableFilter={enableFilterOnExport}
                setEnableFilter={setEnableFilterOnExport}
                filter={filter}
                setFilter={setFilter}
                showFilters={true}
            />
            <BulkModalAssign
                bulkAssignOpen={bulkAssignOpen}
                handleBulkAssignModelClose={handleBulkAssignModelClose}
            />

            <UpdateDataModal
                open={updateDataModalOpen}
                handleClose={handleUpdateDataModalClose}
                handleOpen={handleUpdateDataModalOpen}
                setData={setData}
            />

            <Modal
                open={openAssignAutoFiltered}
                handleClose={() => {
                    // setOpenAssignAutoFiltered(false)
                }}
                head={`Assign Filtered Cases`}
                buttons={[
                    ...(assigningFilteredState === false ||
                        assigningFilteredState === "completed"
                        ? [
                            {
                                name: "Close",
                                onClick: () => {
                                    setOpenAssignAutoFiltered(false);
                                },
                            },
                        ]
                        : []),
                ]}
            // styleA={"md"}
            >
                <Box sx={{ pl: 2 }}>
                    <Box
                        sx={{ color: "#57595a", pl: 1, borderLeft: "2px solid #57595a" }}
                    >
                        <Typography>Total Filtered Cases: {countF}</Typography>
                    </Box>

                    <Box sx={{ pt: 1, color: "green", fontWeight: "bold", mt: 2 }}>
                        <Typography>Queued Cases: {queueCount}</Typography>
                    </Box>

                    <Box sx={{ pt: 1 }}>
                        <Button
                            variant="contained"
                            color="success"
                            disabled={
                                assignFilteredCases.length == 0 ||
                                assigningFilteredState == "completed" ||
                                assigningFilteredState == "progress"
                            }
                            onClick={() => {
                                setAssigningFilteredState("progress");
                                setAssignOverview(null);
                                axios
                                    .post(API_HOST_CRM + "/allocate-auto-selected2", {
                                        cases: assignFilteredCases,
                                    })
                                    .then((resp) => {
                                        if (resp.data && resp.data.success) {
                                            setAssignOverview(resp.data.data);
                                            setAssigningFilteredState("completed");
                                            setTimeout(() => {
                                                // setAssigningFilteredState(false)
                                            }, 1000);
                                            getList();
                                        } else {
                                            setAssigningFilteredState(false);
                                            getList();
                                        }
                                    })
                                    .catch((e) => {
                                        setAssigningFilteredState(false);
                                        getList();
                                        console.log(e);
                                    });
                            }}
                            size="small"
                            sx={{ width: "max-content" }}
                        >
                            {assigningFilteredState == "progress"
                                ? "Assigning....."
                                : assigningFilteredState == "completed"
                                    ? "Assign completed"
                                    : "Assign Queued Cases"}
                        </Button>
                    </Box>
                    <Box sx={{}}>
                        {assignOverview && (
                            <Box sx={{ width: "100%", mt: 3 }}>
                                <Box
                                    sx={{
                                        color: "#57595a",
                                        pl: 1,
                                        borderLeft: "2px solid #57595a",
                                    }}
                                >
                                    <Typography>Assign Result:</Typography>
                                </Box>
                                <Box sx={{}}>
                                    {/* <Box sx={{display: 'flex'}}>
                    </Box>
                  {
                    assignOverview.map(e => {
                      return (
                        <Box>
                          <Typography>{e.name} : {e.allocatable.length}</Typography>
                        </Box>
                      )
                    })
                  } */}
                                    <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                                        <Table
                                            stickyHeader
                                            sx={{ minWidth: 350 }}
                                            aria-label="simple table"
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Telecaller</TableCell>
                                                    <TableCell align="right">Assigned</TableCell>
                                                    <TableCell align="right">Total Assigned</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {assignOverview.map((row) => (
                                                    <TableRow
                                                        key={row.name}
                                                        sx={{
                                                            "&:last-child td, &:last-child th": { border: 0 },
                                                        }}
                                                    >
                                                        <TableCell
                                                            component="th"
                                                            scope="row"
                                                            sx={{ color: "#57595a" }}
                                                        >
                                                            {row.name}
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ color: "#57595a" }}>
                                                            {row.allocatable.length}
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ color: "#57595a" }}>
                                                            {row.alreadyAssignedCount +
                                                                row.allocatable.length +
                                                                "/" +
                                                                row.limit}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                                <Box sx={{ mt: 2 }}>
                                    <TableRow>
                                        {/* <TableCell rowSpan={3} /> */}
                                        <TableCell colSpan={2}>Telecallers:</TableCell>
                                        <TableCell align="right">{assignOverview.length}</TableCell>
                                        {/* <TableCell rowSpan={2} /> */}
                                        <TableCell colSpan={2} sx={{ color: "green" }}>
                                            Assigned:
                                        </TableCell>
                                        <TableCell align="right" sx={{ color: "green" }}>
                                            {assignOverview.reduce((a, e) => {
                                                a += e.allocatable.length;
                                                return a;
                                            }, 0)}
                                        </TableCell>
                                        {/* <TableCell rowSpan={2} /> */}
                                        <TableCell colSpan={2} sx={{ color: "brown" }}>
                                            Remaining Queued:
                                        </TableCell>
                                        <TableCell align="right" sx={{ color: "brown" }}>{`${queueCount -
                                            assignOverview.reduce((a, e) => {
                                                a += e.allocatable.length;
                                                return a;
                                            }, 0)
                                            }`}</TableCell>
                                    </TableRow>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Modal>
        </>
    );
};
